var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "zoom-controls btn-group" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-sm btn-outline-secondary",
        attrs: { type: "button", disabled: !_vm.state.media, title: "Zoom in" },
        on: { click: _vm.zoomIn }
      },
      [_vm._v("+")]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-sm btn-outline-secondary",
        attrs: {
          type: "button",
          disabled: !_vm.state.media,
          title: "Zoom out"
        },
        on: { click: _vm.zoomOut }
      },
      [_vm._v("−")]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-sm btn-outline-secondary",
        attrs: { type: "button", disabled: !_vm.state.media, title: "Fit" },
        on: { click: _vm.fitToContainer }
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("maintenance.overview2d.zoomControls.fit")) +
            "\n  "
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }